<section id="cta" class="wrapper style4">
	<div class="inner">
		<header>
			<h2>King Clean Your Cans!</h2>
			<p>Sign up today, starting at $25/month</p>
		</header>
		<ul class="actions stacked">
			<li><a href="/contact" class="button fit primary">Subscribe</a></li>
			<li><a href="/about" class="button fit">Learn More</a></li>
		</ul>
	</div>
</section>
